import { ChevronLeft, ChevronRight } from 'lucide-react';

interface SidebarProps {
  activeView: string;
  treeViewContent?: React.ReactNode;
  collapsed?: boolean;
  onToggleCollapse?: () => void;
}

export function Sidebar({ activeView, treeViewContent, collapsed = false, onToggleCollapse }: SidebarProps) {
  const showTree = activeView === 'dashboard' && !!treeViewContent;

  return (
    <div className={`${collapsed ? 'w-16' : 'w-56'} bg-gradient-to-b from-white to-gray-50 border-r border-gray-200 flex flex-col transition-all duration-300 relative z-40`}>
      {onToggleCollapse && (
        <button
          onClick={onToggleCollapse}
          className="absolute top-6 -right-3 z-10 w-6 h-6 bg-white border border-gray-200 rounded-full flex items-center justify-center shadow-md hover:bg-gray-50 transition-colors"
          title={collapsed ? 'Expand' : 'Collapse'}
        >
          {collapsed ? (
            <ChevronRight className="w-4 h-4 text-gray-600" />
          ) : (
            <ChevronLeft className="w-4 h-4 text-gray-600" />
          )}
        </button>
      )}

      {!collapsed && showTree && (
        <div className="flex-1 overflow-y-auto px-3 py-4">
          {treeViewContent}
        </div>
      )}
    </div>
  );
}
